import { render, staticRenderFns } from "./LiveRoom.vue?vue&type=template&id=ed695afa&scoped=true&"
import script from "./LiveRoom.vue?vue&type=script&lang=js&"
export * from "./LiveRoom.vue?vue&type=script&lang=js&"
import style0 from "./LiveRoom.vue?vue&type=style&index=0&id=ed695afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed695afa",
  null
  
)

component.options.__file = "LiveRoom.vue"
export default component.exports